import React,{PropTypes} from 'react';
import {Modal} from 'react-overlays';
import EstablishmentSubmitForm from './EstablishmentSubmitForm';
import '../../styles/modals/establishmentSubmitModal.css';


const EstablishmentSubmitModal = ({
  showModal,
  onHide,
  submitForm,
  onSubmit,
  onClick,
  isActive,
  numberOfEstablishments,
  onChange,
  isResubmit,
  resubmissionReason
})=> {

  const backdropStyle = {
    position: 'fixed',
    top: 0, bottom: 0, left: 0, right: 0,
    zIndex: 'auto',
    backgroundColor: '#000',
    opacity: 0.5
  };

	return (
    <Modal
      className="establishment-modal"
      backdropStyle={backdropStyle}
      show={showModal}
      onHide={onHide}>
      <div className="establishment-modal-dialog">
        <EstablishmentSubmitForm
          form={submitForm}
          hideSubmitPage={onHide}
          onClick={onClick}
          onSubmit={onSubmit}
          isActive={isActive}
          numOfEstablishments={numberOfEstablishments}
          onChange={onChange}
          isResubmit={isResubmit}
          resubmissionReason={resubmissionReason}/>
      </div>
    </Modal>
	);
};

EstablishmentSubmitModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  submitForm: PropTypes.object.isRequired,
  isResubmit: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  resubmissionReason: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  numberOfEstablishments: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default EstablishmentSubmitModal;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentSubmitModal.js
 **/